import React from 'react';

function FooterFloor() {
    return (
        <div className="container content-floor">
            <div>© medtab<a href="" className="content-floor__footer-links"> 2021 </a>| All Rights Reserved</div>
            <div>
                <ul>
                    <li><a href="/">Privacy</a></li>
                    <li><a href="/">Terms</a></li>
                    <li><a href="/">Sitemap</a></li>
                    <li><a href="/">Help</a></li>
                </ul>
            </div>
        </div>
    );
}

export default FooterFloor;